// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Signature_container__CRAYG {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px;
  background: white;
  border-radius: 12px;
  box-shadow: 0px 4px 6px 4px rgba(0, 0, 0, 0.1);
  margin-top: 50px;
}

.Signature_title__NzwKD {
  color: #333;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
}

.Signature_subtitle__kX13t {
  color: #666;
  font-size: 14px;
  text-align: center;
  margin-bottom: 30px;
}

.Signature_modeSelector__yNAoD {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.Signature_modeButton__Quhvq {
  padding: 12px 24px;
  border: 2px solid #fd5e63;
  background: transparent;
  color: #fd5e63;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.Signature_modeButton__Quhvq:hover {
  background: #fff5f5;
}

.Signature_modeButton__Quhvq.Signature_active__aaL1F {
  background: #fd5e63;
  color: white;
}

.Signature_signatureArea__bAeOG {
  margin-bottom: 30px;
}

.Signature_drawArea__DVuvv {
  border: 2px dashed #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: rgb(247, 248, 249);
}

.Signature_signatureCanvas__Gb1DA {
  width: 100% !important;
  height: 200px !important;
  cursor: crosshair;
}

.Signature_uploadArea__TEc3W {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 40px;
  border: 2px dashed #e0e0e0;
  border-radius: 8px;
  background: rgb(247, 248, 249);
}

.Signature_uploadButton__-IR92 {
  padding: 12px 24px;
  background: #fd5e63;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  border: none;
}

.Signature_uploadButton__-IR92:hover {
  background: #f7595f;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(253, 94, 99, 0.2);
}

.Signature_previewArea__t44Nk {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 15px;
  border-radius: 4px;
  margin-top: 15px;
}

.Signature_signaturePreview__bfCLy {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
}

.Signature_error__GKlrP {
  color: #fd5e63;
  font-size: 14px;
  text-align: center;
  margin: 10px 0;
}

.Signature_buttonGroup__GRJIN {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
}

.Signature_clearButton__wsapS {
  padding: 12px 30px;
  background: #f0f0f0;
  color: #666;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.Signature_clearButton__wsapS:hover {
  background: #e0e0e0;
}

.Signature_submitButton__u8x2i {
  padding: 12px 40px;
  background: #fd5e63;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.Signature_submitButton__u8x2i:hover {
  background: #f7595f;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(253, 94, 99, 0.2);
}

.Signature_uploadText__ddUoM{
    color:#666;
    margin-top: -10px;
    font-size: 12px;
}

.Signature_cropContainer__9Niuf {
  width: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.Signature_cropText__eEomA {
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
}

.Signature_cropImage__OxaZS {
  max-width: 100%;
  height: auto;
  display: block;
}

.Signature_cropButton__u4xZn {
  padding: 10px 24px;
  background: #fd5e63;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 15px;
}

.Signature_cropButton__u4xZn:hover {
  background: #f7595f;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(253, 94, 99, 0.2);
}

.ReactCrop__crop-selection {
  border: 2px solid #fd5e63 !important;
}

.ReactCrop__drag-handle {
  background-color: #fd5e63 !important;
}

.ReactCrop__drag-handle::after {
  background-color: #fd5e63 !important;
}

.Signature_loaderModal__5BObu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.Signature_loaderContent__vA2cR {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.Signature_loaderSpinner__paDKP {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #fd5e63;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: Signature_spin__GkpFN 1s linear infinite;
  margin: 0 auto 16px;
}

.Signature_loaderText__zbrLi {
  color: #333;
  font-size: 16px;
  margin: 0;
}

@keyframes Signature_spin__GkpFN {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.Signature_submitButton__u8x2i:disabled,
.Signature_clearButton__wsapS:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/organism/Signature.module.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["\n.container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 30px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0px 4px 6px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 50px;\n}\n\n.title {\n  color: #333;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  text-align: center;\n}\n\n.subtitle {\n  color: #666;\n  font-size: 14px;\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.modeSelector {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.modeButton {\n  padding: 12px 24px;\n  border: 2px solid #fd5e63;\n  background: transparent;\n  color: #fd5e63;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.modeButton:hover {\n  background: #fff5f5;\n}\n\n.modeButton.active {\n  background: #fd5e63;\n  color: white;\n}\n\n.signatureArea {\n  margin-bottom: 30px;\n}\n\n.drawArea {\n  border: 2px dashed #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: rgb(247, 248, 249);\n}\n\n.signatureCanvas {\n  width: 100% !important;\n  height: 200px !important;\n  cursor: crosshair;\n}\n\n.uploadArea {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding: 40px;\n  border: 2px dashed #e0e0e0;\n  border-radius: 8px;\n  background: rgb(247, 248, 249);\n}\n\n.uploadButton {\n  padding: 12px 24px;\n  background: #fd5e63;\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  border: none;\n}\n\n.uploadButton:hover {\n  background: #f7595f;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(253, 94, 99, 0.2);\n}\n\n.previewArea {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: white;\n  padding: 15px;\n  border-radius: 4px;\n  margin-top: 15px;\n}\n\n.signaturePreview {\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 10px;\n}\n\n.error {\n  color: #fd5e63;\n  font-size: 14px;\n  text-align: center;\n  margin: 10px 0;\n}\n\n.buttonGroup {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.clearButton {\n  padding: 12px 30px;\n  background: #f0f0f0;\n  color: #666;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.clearButton:hover {\n  background: #e0e0e0;\n}\n\n.submitButton {\n  padding: 12px 40px;\n  background: #fd5e63;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.submitButton:hover {\n  background: #f7595f;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(253, 94, 99, 0.2);\n}\n\n.uploadText{\n    color:#666;\n    margin-top: -10px;\n    font-size: 12px;\n}\n\n.cropContainer {\n  width: 100%;\n  margin: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.cropText {\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.cropImage {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.cropButton {\n  padding: 10px 24px;\n  background: #fd5e63;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 15px;\n}\n\n.cropButton:hover {\n  background: #f7595f;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(253, 94, 99, 0.2);\n}\n\n:global(.ReactCrop__crop-selection) {\n  border: 2px solid #fd5e63 !important;\n}\n\n:global(.ReactCrop__drag-handle) {\n  background-color: #fd5e63 !important;\n}\n\n:global(.ReactCrop__drag-handle::after) {\n  background-color: #fd5e63 !important;\n}\n\n.loaderModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.loaderContent {\n  background-color: white;\n  padding: 24px;\n  border-radius: 8px;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.loaderSpinner {\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #fd5e63;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n.loaderText {\n  color: #333;\n  font-size: 16px;\n  margin: 0;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.submitButton:disabled,\n.clearButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Signature_container__CRAYG`,
	"title": `Signature_title__NzwKD`,
	"subtitle": `Signature_subtitle__kX13t`,
	"modeSelector": `Signature_modeSelector__yNAoD`,
	"modeButton": `Signature_modeButton__Quhvq`,
	"active": `Signature_active__aaL1F`,
	"signatureArea": `Signature_signatureArea__bAeOG`,
	"drawArea": `Signature_drawArea__DVuvv`,
	"signatureCanvas": `Signature_signatureCanvas__Gb1DA`,
	"uploadArea": `Signature_uploadArea__TEc3W`,
	"uploadButton": `Signature_uploadButton__-IR92`,
	"previewArea": `Signature_previewArea__t44Nk`,
	"signaturePreview": `Signature_signaturePreview__bfCLy`,
	"error": `Signature_error__GKlrP`,
	"buttonGroup": `Signature_buttonGroup__GRJIN`,
	"clearButton": `Signature_clearButton__wsapS`,
	"submitButton": `Signature_submitButton__u8x2i`,
	"uploadText": `Signature_uploadText__ddUoM`,
	"cropContainer": `Signature_cropContainer__9Niuf`,
	"cropText": `Signature_cropText__eEomA`,
	"cropImage": `Signature_cropImage__OxaZS`,
	"cropButton": `Signature_cropButton__u4xZn`,
	"loaderModal": `Signature_loaderModal__5BObu`,
	"loaderContent": `Signature_loaderContent__vA2cR`,
	"loaderSpinner": `Signature_loaderSpinner__paDKP`,
	"spin": `Signature_spin__GkpFN`,
	"loaderText": `Signature_loaderText__zbrLi`
};
export default ___CSS_LOADER_EXPORT___;
